import React, { useEffect, useRef, useState } from 'react';
import env from '../../../../../environment';
import authClient from '../../../../../Auth/Auth';
import {
	Table,
	Select,
	Button,
	Popconfirm,
	Radio,
	Checkbox,
	Modal,
	Tooltip,
	Typography,
	Space,
	notification,
	Input,
	Divider,
	Col,
	Row,
	Grid
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';
import moment from 'moment';
import _ from 'lodash';
import {
	FilterIcon,
	FilterMailSquareIcon,
	RotateTopLeftIcon,
	RotateTopRightIcon,
	NoteRemoveIcon
} from 'hugeicons-react';
import { useParams } from 'react-router-dom';
import { isEncryptedPdf } from './PDFFunctions';

const { Text } = Typography;

const { Option } = Select;
const { useBreakpoint } = Grid;

const TableAndColumnsFile = ({
	getSelectDocumentTypes,
	loadSignedDocument,
	dataDocuments,
	onChangeCheckBox,
	onCheckAllChange,
	unCheckBox,
	mortgageData,
	participants,
	guarantors,
	saveData,
	checkAll,
	indeterminate,
	checkedList,
	profile,
	fileErrorId,
	selectDocument,
	setSelectDocument,
	notVerified,
	reloadFile,
	index
}) => {
	const token = authClient.getToken();
	const statusJob = useSelector((state) => state.formaTasaci.statusJob);
	const documents = useSelector((state) => state.documentation.documents);
	const [priorityChecked, setPriorityChecked] = useState(false);
	const [filesCompleteVerified, setFilesCompleteVerifiedTMP] = useState(dataDocuments);
	const [filesComplete, setFilesCompleteTMP] = useState(dataDocuments);
	const [filesIncomplete, setFilesIncompleteTMP] = useState(dataDocuments);
	const [searchValue, setSearchValue] = useState({});
	const [newTagValue, setNewTagValue] = useState({});
	const [openSelect, setOpenSelect] = useState({});
	const params = useParams();
	const id = params.mortgageId;

	const screens = useBreakpoint();

	const dispatch = useDispatch();
	const [rotation, setRotation] = useState(0);

	const viewerRef = useRef(null);

	let excludedNames = [
		'consent_ibercaja',
		'consent_caixabank',
		'consent_sabadell_saas',
		'consent_unicaja',
		'consent_abanca',
		'consent_globalcaja',
		'consent_bankinter',
		'consent_caja_rural_sur',
		'consent_kutxabank',
		'consent_bbva'
	];

	useEffect(() => {
		if (!viewerRef.current) return;

		const iframe =
			viewerRef.current.querySelector('iframe') ||
			viewerRef.current.querySelector('canvas') ||
			viewerRef.current.querySelector('img');

		if (iframe) {
			iframe.style.transform = `rotate(${rotation}deg)`;
			iframe.style.transformOrigin = 'center center';
			iframe.style.transition = 'transform 0.2s ease';
		}
	}, [rotation]);

	const removeFile = async (documentId) => {
		const response = await axios.get(`${env.api.url}/v1/documents/delete-document/${documentId}`, {
			headers: { Authorization: `Bearer ${token}` }
		});
		reloadFile();
	};

	const arrayOptionsPage = [];
	arrayOptionsPage.push(
		<Option key={'t'} value={'t'}>
			{'T'}
		</Option>
	);
	for (let i = 1; i < 51; i++) {
		arrayOptionsPage.push(
			<Option key={i} value={`${i}`}>
				{i}
			</Option>
		);
	}

	const renderCheck = (dataValue, model) => {
		if (dataValue && model.isVerified) {
			return dataValue;
		} else {
			return model.isVerified;
		}
	};

	const orderByPriority = () => {
		const orderedTypes = [
			'nif',
			'laboralLife',
			'irpf2',
			'irpf',
			'payroll',
			'statement303',
			'bankreader',
			'statement130',
			'simpleNote',
			'appraisal',
			'contract'
		];

		let dataDocuments = undefined;
		if (index === 1) {
			dataDocuments = filesIncomplete;
		} else if (index === 2) {
			dataDocuments = filesComplete;
		} else {
			dataDocuments = filesCompleteVerified;
		}

		// 1️⃣ Agrupar por titular (owner)
		const groupedByOwner = dataDocuments.reduce((acc, doc) => {
			if (!acc[doc.owner]) acc[doc.owner] = [];
			acc[doc.owner].push(doc);
			return acc;
		}, {});

		// 2️⃣ Obtener titulares ordenados (owner1, owner2, owner3...)
		const orderedOwners = Object.keys(groupedByOwner).sort((a, b) =>
			a.localeCompare(b, undefined, { numeric: true })
		);

		const finalResult = [];

		// 3️⃣ Ordenar cada bloque de titular
		orderedOwners.forEach((owner) => {
			const docs = groupedByOwner[owner];

			const orderedDocs = [];
			const unorderedDocs = [];

			docs.forEach((doc) => {
				if (orderedTypes.includes(doc.type)) {
					orderedDocs.push(doc);
				} else {
					unorderedDocs.push(doc); // no se reordenan
				}
			});

			// 4️⃣ Ordenar SOLO los relevantes por type
			orderedDocs.sort((a, b) => {
				return orderedTypes.indexOf(a.type) - orderedTypes.indexOf(b.type);
			});

			// 5️⃣ Unir por titular: primero relevantes, luego los otros sin tocar
			finalResult.push(...orderedDocs, ...unorderedDocs);
		});

		return finalResult;
	};

	const hasResultsForValue = (value) => {
		const search = value.toLowerCase();

		return documents.some(
			(doc) => doc.title.toLowerCase().includes(search) || doc.name.toLowerCase().includes(search)
		);
	};

	const handleSearchChange = (modelId, value, source) => {
		if (!value) {
			setSearchValue((prev) => ({ ...prev, [modelId]: '' }));
			setNewTagValue((prev) => ({ ...prev, [modelId]: '' }));
			return;
		}

		const hasResults = hasResultsForValue(value);

		setSearchValue((prev) => ({ ...prev, [modelId]: value }));

		if (!hasResults) {
			setNewTagValue((prev) => ({ ...prev, [modelId]: value }));
		} else if (source === 'select') {
			setNewTagValue((prev) => ({ ...prev, [modelId]: '' }));
		}
	};

	const addDocumentType = (groupKey, value, modelId) => {
		axios
			.post(
				`${env.api.url}/v1/document-types/create-operation-document`,
				{
					title: value,
					name: value,
					operationId: id,
					operationType: 'mortgage',
					group: groupKey
				},
				{
					headers: { Authorization: `Bearer ${token}` }
				}
			)
			.then(() => {
				saveData(modelId, 'type', value);
				notification.success({
					message: 'Etiqueta añadida correctamente'
				});
				window.location.reload();
			})
			.catch((error) => {
				notification.error({
					message: 'Error al añadir el tipo de documento'
				});
				console.error(error);
			});
	};

	const addItem = (e, modelId) => {
		e.preventDefault();

		const value = newTagValue[modelId];
		if (!value) return;

		addDocumentType('others', value, modelId);
		setNewTagValue((prev) => ({ ...prev, [modelId]: '' }));
		setOpenSelect((prev) => ({ ...prev, [modelId]: false }));
	};

	const renderDisabled = (status, dataValue) => {
		if (authClient.getProfile().managementCode === 'sabadell-es') {
			excludedNames = excludedNames.filter((name) => name !== 'consent_sabadell_saas');
		}
		if (status === 'finish') {
			return true;
		} else {
			if (excludedNames.includes(dataValue)) {
				return true;
			} else {
				return false;
			}
		}
	};

	const renderLabel = (dataValue) => {
		if (dataValue === 'consent_ibercaja') {
			return 'Consentimiento de datos: Ibercaja';
		}
		if (dataValue === 'consent_caixabank') {
			return 'Consentimiento de datos: Caixabank';
		}
		if (dataValue === 'consent_sabadell_saas') {
			return 'Consentimiento de datos: Sabadell';
		}
		if (dataValue === 'consent_bankinter') {
			return 'Consentimiento de datos: Bankinter';
		}
		if (dataValue === 'consent_unicaja') {
			return 'Consentimiento de datos: Unicaja';
		}
		if (dataValue === 'consent_abanca') {
			return 'Consentimiento de datos: Abanca';
		}
		if (dataValue === 'consent_globalcaja') {
			return 'Consentimiento de datos: Globalcaja';
		}
		if (dataValue === 'consent_caja_rural_sur') {
			return 'Consentimiento de datos: Caja Rural Sur';
		}
		if (dataValue === 'consent_kutxabank') {
			return 'Consentimiento de datos: Kutxabank';
		}
		if (dataValue === 'consent_bbva') {
			return 'Consentimiento de datos: BBVA';
		} else {
			return dataValue;
		}
	};

	const columnsFiles = [
		{
			title: (
				<div style={{ fontWeight: 600, fontSize: '12px' }}>
					<Checkbox
						indeterminate={indeterminate}
						onChange={onCheckAllChange}
						checked={checkAll}
						style={{ marginRight: 8 }}
					/>
					{index === 1 && 'Fichero'}
				</div>
			),
			dataIndex: 'name',
			key: 'name',
			width: index === 1 ? '15%' : '80px',
			render: (text, data) => (
				<div style={{ display: 'flex' }}>
					<Checkbox.Group
						style={{ alignSelf: 'center', marginRight: 24, marginTop: -3 }}
						value={checkedList}
						onChange={onChangeCheckBox}>
						<Checkbox value={data.id} onChange={(e) => unCheckBox(e.target.value)}></Checkbox>
					</Checkbox.Group>

					{data.size > 10000 && (
						<Tooltip title={'Este archivo ocupa más de 10M'}>
							<img
								src="/images/Icon.png"
								alt="icon"
								style={{ width: 16, height: 16, marginLeft: -10, marginRight: 10 }}></img>
						</Tooltip>
					)}

					{index === 1 && (
						<Tooltip title={text}>
							<div
								style={{
									width: 240,
									textOverflow: 'ellipsis',
									overflow: 'hidden',
									whiteSpace: 'pre'
								}}>
								<Text style={{ color: '#02C3CD', fontWeight: 600, fontSize: 12 }}>{text}</Text>
							</div>
						</Tooltip>
					)}
				</div>
			)
		},
		{
			title: <div style={{ fontWeight: 600, fontSize: '12px', width: '112px' }}>Fecha</div>,
			dataIndex: 'createdAt',
			key: 'createdAt',
			width: '12%',
			render: (date) => (
				<>
					<div style={{ textAlign: 'center' }}>
						<Text style={{ color: '#2F4858', fontSize: 12, fontWeight: 500 }}>
							{moment(date).format('YY-MM-DD')}
						</Text>
						<br />
						<Text style={{ color: '#2F4858', fontSize: 9, fontWeight: 500 }}>
							{'(' + moment.duration(moment(date).diff(moment())).locale('es').humanize(true) + ')'}
						</Text>
					</div>
				</>
			)
		},
		{
			title: <div style={{ fontWeight: 600, fontSize: '12px' }}>Titular</div>,
			dataIndex: 'owner',
			key: 'owner',
			width: '100px',
			filters: [
				...Array.from({ length: participants }, (_, i) => ({
					text: `T${i + 1}: ${mortgageData[`owner${i + 1}`]?.name || 'N/A'}`,
					value: `owner${i + 1}`
				})),
				...Array.from({ length: guarantors }, (_, i) => ({
					text: `A${i + 1}: ${mortgageData[`guarantor${i + 1}`]?.name || 'N/A'}`,
					value: `guarantor${i + 1}`
				}))
			],
			onFilter: (value, record) => {
				return record.owner === value;
			},
			filterIcon: (filtered) => (
				<FilterIcon size={14} style={{ color: filtered ? '#006DFF' : '#757575' }} />
			),
			render: (dataValue, model) => {
				const participantsOptions = [];
				const guarantorsOptions = [];
				for (let i = 1; i <= participants; i++) {
					participantsOptions.push(
						<Option key={`owner-option-${i}`} value={`owner${i}`}>
							T{i}: {mortgageData && mortgageData[`owner${i}`] && mortgageData[`owner${i}`].name}
						</Option>
					);
				}

				for (let i = 0; i < guarantors; i++) {
					guarantorsOptions.push(
						<Option key={`guarantors-option-${i + 1}`} value={`guarantor${i + 1}`}>
							A{i + 1}:{' '}
							{mortgageData &&
								mortgageData[`guarantor${i + 1}`] &&
								mortgageData[`guarantor${i + 1}`].name}
						</Option>
					);
				}

				return (
					<Select
						disabled={statusJob === 'finish' ? true : false}
						style={{ width: '100%' }}
						defaultValue={dataValue}
						key={model.id}
						onChange={(value) => {
							saveData(model.id, 'owner', value);
							//setSelectDocument([model.id]);
						}}>
						{participantsOptions}
						{guarantorsOptions}
					</Select>
				);
			}
		},
		{
			title: <div style={{ fontWeight: 600, fontSize: '12px' }}>Tipo de documento</div>,
			dataIndex: 'type',
			key: 'type',
			width: '25%',
			filters: [{ value: 'priority', text: 'Ordenar por relevancia' }],
			filterIcon: (filtered) => (
				<FilterMailSquareIcon
					size={16}
					style={{
						color: priorityChecked ? '#1890ff' : undefined
					}}
				/>
			),

			onFilter: (value, record) => {
				return true;
			},
			filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
				<div style={{ padding: 8, width: 200 }}>
					<Checkbox
						checked={priorityChecked}
						onChange={(e) => {
							setPriorityChecked(e.target.checked);
						}}
						style={{ cursor: 'pointer' }}>
						Ordenar por relevancia
					</Checkbox>
					<Space style={{ marginTop: 16 }}>
						<Button
							onClick={() => {
								if (index === 1) {
									setFilesIncompleteTMP(dataDocuments);
									setPriorityChecked(false);
								} else if (index === 2) {
									setFilesCompleteTMP(dataDocuments);
									setPriorityChecked(false);
								} else if (index === 3) {
									setFilesCompleteVerifiedTMP(dataDocuments);
									setPriorityChecked(false);
								}

								confirm();
							}}
							size="small"
							style={{ width: 90 }}>
							Reiniciar
						</Button>
						<Button
							type="primary"
							onClick={() => {
								// marcar checkbox → ordenar por prioridad
								if (priorityChecked) {
									const ordered = orderByPriority();
									if (index === 1) {
										setFilesIncompleteTMP(ordered);
									} else if (index === 2) {
										setFilesCompleteTMP(ordered);
									} else if (index === 3) {
										setFilesCompleteVerifiedTMP(ordered);
									}
								} else {
									// desmarcar checkbox → volver al orden original
									if (index === 1) {
										setFilesIncompleteTMP(dataDocuments);
									} else if (index === 2) {
										setFilesCompleteTMP(dataDocuments);
									} else if (index === 3) {
										setFilesCompleteVerifiedTMP(dataDocuments);
									}
								}

								confirm({ closeDropdown: true });
							}}
							size="small"
							style={{ width: 90 }}>
							Aceptar
						</Button>
					</Space>
				</div>
			),

			render: (dataValue, model) => {
				return (
					<Select
						open={!!openSelect[model.id]}
						searchValue={searchValue[model.id] || ''}
						onDropdownVisibleChange={(open) =>
							setOpenSelect((prev) => ({ ...prev, [model.id]: open }))
						}
						showSearch
						onSearch={(value) => handleSearchChange(model.id, value, 'select')}
						filterOption={(input, option) => {
							return (
								option?.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0 ||
								option?.value?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
							);
						}}
						notFoundContent={
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									gap: 4,
									padding: 10,
									justifyContent: 'center'
								}}>
								<NoteRemoveIcon size={16} color="#748EA0" />
								<Text style={{ fontSize: 12, marginTop: 4, color: '#748EA0' }}>
									No hay etiquetas con ese nombre
								</Text>
							</div>
						}
						disabled={renderDisabled(status, dataValue)}
						placeholder="Seleccionar"
						style={{ width: '100%' }}
						defaultValue={renderLabel(dataValue)}
						key={model.id}
						onChange={(value) => {
							saveData(model.id, 'type', value);
							setOpenSelect((prev) => ({ ...prev, [model.id]: false }));
						}}
						dropdownRender={(menu) => (
							<>
								{menu}
								<Divider style={{ margin: '8px 0' }} />
								<div style={{ padding: '4px 8px' }}>
									<Text style={{ fontSize: 10, fontWeight: 600 }}>
										Añadir nueva etiqueta de documento
									</Text>
									<Row gutter={8} wrap={false}>
										<Col flex="1 1 auto">
											<Input
												size="small"
												placeholder="Escribe nombre nueva etiqueta"
												value={newTagValue[model.id] || ''}
												onChange={(e) => {
													const value = e.target.value;
													setNewTagValue((prev) => ({ ...prev, [model.id]: value }));
													handleSearchChange(model.id, value, 'input');
												}}
												onKeyDown={(e) => e.stopPropagation()}
											/>
										</Col>
										<Col flex="none">
											<Button
												type="primary"
												size="small"
												onClick={(e) => addItem(e, model.id)}
												disabled={!newTagValue[model.id]}>
												Añadir
											</Button>
										</Col>
									</Row>
								</div>
							</>
						)}>
						{getSelectDocumentTypes()}
					</Select>
				);
			}
		},
		{
			title: <div style={{ fontWeight: 600, fontSize: '12px' }}>Página</div>,
			dataIndex: 'page',
			key: 'page',
			width: '40px',
			render: (dataValue, model) => {
				return (
					<Select
						key={model.id}
						showSearch
						disabled={statusJob === 'finish' ? true : false}
						defaultValue={dataValue}
						style={{ width: 54, height: 24 }}
						onChange={(value) => saveData(model.id, 'page', value)}>
						{arrayOptionsPage}
					</Select>
				);
			}
		},
		{
			title: <div style={{ fontWeight: 600, fontSize: '12px' }}>Verificado</div>,
			dataIndex: 'isVerified',
			key: 'isVerified',
			width: '80px',
			render: (dataValue, model) => {
				return (
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<Checkbox
							key={model.id}
							defaultChecked={renderCheck(dataValue, model)}
							onChange={(value) => {
								saveData(model.id, 'isVerified', value.target.checked);
							}}></Checkbox>
						{/*model.source === 'Hadmin' && _.isNil(model.suggest) && index > 2 &&(
							<img
								src="/images/hadmin.png"
								alt="asf"
								height={14}
								width={16}
								style={{ marginLeft: 16, marginTop: 3 }}></img>
						)*/}
						{model.source === 'BANKFLIP_SESSION_B2C' && index > 2 && (
							<img
								src="/images/bankflip.png"
								alt="as"
								height={14}
								width={16}
								style={{ marginLeft: 16, marginTop: 3 }}></img>
						)}
						{/*!_.isNil(model.suggest) &&  model.source !== 'BANKFLIP_SESSION_B2C'&& index > 2 && (
							<img
								src="/images/ocr.png"
								alt="wret"
								height={14}
								width={16}
								style={{ marginLeft: 16, marginTop: 3 }}></img>
						)*/}
					</div>
				);
			}
		},

		{
			title: <div style={{ fontWeight: 600, fontSize: '12px' }}>Acciones</div>,
			key: 'actions',
			width: '120px',
			render: (text, data) => {
				const url = `${env.api.viewer}/api/document/${data.key}/attachment?token=${token}`;

				return (
					<div style={{ display: 'flex' }}>
						<Button
							type="link"
							onClick={async () => {
								const { url, name, mime, fileData } = await loadSignedDocument(data.id);
								setSelectDocument([data.id]);
								const encrypted = mime === 'application/pdf' ? await isEncryptedPdf(url) : false;

								if (encrypted) {
									Modal.warning({
										title: 'Documento protegido',
										closable: true,
										okText: 'Descargar',
										content: 'Este PDF está protegido con contraseña. Descárgalo para abrirlo.',
										onOk: () => {
											window.location.href = url;
										}
									});
									return;
								}

								const showModal = Modal.confirm({
									className: 'gb-modal-24-padding',
									title: 'Visualizar fichero',
									content: (
										<>
											<div style={{ marginBottom: 8 }}>
												<Button onClick={() => setRotation((r) => r - 90)}>
													<RotateTopLeftIcon />
												</Button>
												<Button
													style={{ marginLeft: 12 }}
													onClick={() => setRotation((r) => r + 90)}>
													<RotateTopRightIcon />
												</Button>
											</div>

											<div ref={viewerRef}>
												<DocViewer
													pluginRenderers={DocViewerRenderers}
													documents={[{ uri: url, fileType: mime, fileData }]}
												/>
											</div>
										</>
									),
									closable: true,
									okCancel: true,
									width: '100%',
									onOk: () => {
										document.location = url;
									},
									okText: 'Descargar',
									cancelText: 'Cerrar',
									onCancel: () => {
										showModal.destroy();
									}
								});
							}}
							style={{ marginRight: -15, color: '#02C3CD' }}>
							<EyeOutlined style={{ fontSize: 20, color: '#02C3CD' }} />
						</Button>
						{profile.type === 'risk' || profile.type === 'admin' || profile.type === 'prerisk' ? (
							<Popconfirm
								disabled={statusJob === 'finish' ? true : false}
								title="¿Estás seguro de borrar?"
								onConfirm={() => {
									removeFile(data.id);
								}}
								okText="Si"
								cancelText="No">
								<Button
									disabled={statusJob === 'finish' ? true : false}
									type="link"
									style={{ color: '#02C3CD' }}>
									<DeleteOutlined style={{ fontSize: 20, color: '#02C3CD' }} />
								</Button>
							</Popconfirm>
						) : undefined}
					</div>
				);
			}
		}
	];

	return (
		<>
			<Table
				className={`table-hover-disabled${index}`}
				dataSource={
					index === 1 ? filesIncomplete : index === 2 ? filesComplete : filesCompleteVerified
				}
				columns={columnsFiles}
				pagination={false}
				size="small"
				rowClassName={(record) => {
					const classes = ['small-font-size'];

					if (record.id === fileErrorId) {
						classes.push('documents-list-row-error');
					}
					selectDocument &&
						selectDocument.map((dataSelect) => {
							if (record.id === dataSelect) {
								return classes.push(`table-color-selector`);
							}
						});

					// if (
					//   record.owner &&
					//   record.owner !== '' &&
					//   record.page &&
					//   record.page !== '' &&
					//   record.page !== 'p' &&
					//   record.type &&
					//   record.type !== ''
					// ) {
					//   classes.push('documents-list-row-completed');
					// }

					return classes;
				}}
			/>
		</>
	);
};

export default TableAndColumnsFile;
